// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDeNpyX5dEkwnE-uQMQtCsag39KQGduuwQ",
    authDomain: "e-paq-shop.firebaseapp.com",
    projectId: "e-paq-shop",
    storageBucket: "e-paq-shop.firebasestorage.app",
    messagingSenderId: "594426358117",
    appId: "1:594426358117:web:4d2da16e957d4b5da1598c",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
